import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { 
  FiHome, FiTarget, FiUsers, FiCheckSquare, FiActivity, 
  FiPlayCircle, FiTrendingUp, FiBookOpen, FiSearch, FiSettings, FiHexagon
} from 'react-icons/fi';

const navItems = [
  { name: 'Home', path: '/', icon: FiHome },
  { name: 'Missions', path: '/missions', icon: FiTarget },
  { name: 'Contribution Rooms', path: '/rooms', icon: FiUsers, badge: '2' },
  { name: 'Decisions', path: '/decisions', icon: FiCheckSquare },
  { name: 'Experiments', path: '/experiments', icon: FiActivity },
  { name: 'Execution', path: '/execution', icon: FiPlayCircle },
  { name: 'Performance', path: '/performance', icon: FiTrendingUp },
  { name: 'Learning', path: '/learning', icon: FiBookOpen },
  { name: 'People', path: '/people', icon: FiUsers },
  { name: 'Search', path: '/search', icon: FiSearch },
];

export default function Sidebar() {
  return (
    <aside className="w-64 bg-slate-50 border-r border-slate-200 flex flex-col h-screen">
      <div className="h-16 flex items-center px-6 border-b border-slate-200">
        <div className="flex items-center gap-2 text-slate-900 font-semibold tracking-tight">
          <SafeIcon icon={FiHexagon} className="text-xl text-blue-600" />
          Contribution OS
        </div>
      </div>
      
      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center justify-between px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                isActive 
                  ? 'bg-white text-slate-900 shadow-sm border border-slate-200' 
                  : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900'
              }`
            }
          >
            <div className="flex items-center gap-3">
              <SafeIcon icon={item.icon} className="text-slate-400 text-lg" />
              {item.name}
            </div>
            {item.badge && (
              <span className="bg-amber-100 text-amber-700 py-0.5 px-2 rounded-full text-xs font-semibold">
                {item.badge}
              </span>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-200">
        <NavLink to="/settings" className="flex items-center gap-3 px-3 py-2 text-sm font-medium text-slate-600 rounded-md hover:bg-slate-100">
          <SafeIcon icon={FiSettings} className="text-slate-400 text-lg" />
          Administration
        </NavLink>
      </div>
    </aside>
  );
}